export default "__VITE_ASSET__64cded8a__"